import React from 'react';
import PropTypes from 'prop-types';

const CarouselCustomDot = ({ onClick, ...rest }) => {
  const { index, active } = rest;
  return (
    <li
      data-index={index}
      className={`react-multi-carousel-dot ${
        active ? 'react-multi-carousel-dot--active' : ''
      }`}
    >
      <button
        type="button"
        aria-label={`Go to slide ${index + 1}`}
        onClick={() => onClick()}
      />
    </li>
  );
};

CarouselCustomDot.propTypes = {
  onClick: PropTypes.func,
};

export default CarouselCustomDot;
